import { AppError } from "../../shared/errors/AppError";
import type { MediaKind } from "./mediaTypes";

const IMAGE_MIME_TYPES = new Set(["image/png", "image/jpeg", "image/webp", "image/gif", "image/svg+xml"]);
const VIDEO_MIME_TYPES = new Set(["video/mp4", "video/webm", "video/quicktime"]);

export const ACCEPTED_MEDIA_TYPES = [...IMAGE_MIME_TYPES, ...VIDEO_MIME_TYPES].join(",");

export function getMediaKind(file: File): MediaKind {
  if (IMAGE_MIME_TYPES.has(file.type)) return "image";
  if (VIDEO_MIME_TYPES.has(file.type)) return "video";

  throw new AppError(
    "UNSUPPORTED_MEDIA",
    "This file format is not supported by Alterly yet. Use PNG, JPEG, WebP, GIF, SVG, MP4, WebM, or a browser-decodable MOV.",
  );
}

export function validateMediaFile(file: File): MediaKind {
  if (file.size === 0) {
    throw new AppError("DECODE_FAILED", "The selected file is empty.");
  }

  return getMediaKind(file);
}
